import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import { removeFromCart } from '@jetshop/core/data/mutations/cartMutations.gql';
import React, { useContext } from 'react';
import { Mutation } from 'react-apollo';
import { getRemoveFromCartOptimisticResponse } from './cartMutationUtils';
import { CartIdContext } from '../Cart/CartIdContext';
import logWarningInDev from '../../helpers/logWarningInDev';
const RemoveFromCart = function RemoveFromCart({ cartQuery, children }) {
    if (!cartQuery) {
        logWarningInDev(true, `Using RemoveFromCart without cartQuery prop is deprecated and will not work in the next major release.`);
    }
    const { cartId, setCartId } = useContext(CartIdContext);
    const track = useTracker();
    return (React.createElement(Mutation, { onCompleted: data => {
            if (data.removeFromCart.cart.items.length === 0) {
            }
        }, mutation: removeFromCart }, (mutate, { client }) => {
        return children((itemId, product) => {
            track(trackProductEvent({ action: 'remove', product }));
            return mutate({
                variables: {
                    input: {
                        cartId,
                        itemId
                    }
                },
                optimisticResponse: {
                    removeFromCart: {
                        cart: getRemoveFromCartOptimisticResponse({
                            itemId,
                            client,
                            cartId,
                            setCartId,
                            cartQuery
                        }),
                        __typename: 'CartMutation'
                    }
                }
            });
        });
    }));
};
export default RemoveFromCart;
//# sourceMappingURL=RemoveFromCart.js.map